//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "LiveSelect",
  props: {
    openByWeb: {
      type: Function
    },
    openByClient: {
      type: Function
    }
  },
  data: function data() {
    return {
      show: true
    };
  },
  methods: {
    openWeb: function openWeb() {
      this.openByWeb && this.openByWeb();
      this.show = false;
    },
    openClient: function openClient() {
      this.openByClient && this.openByClient();
      this.show = false;
    }
  }
};